import { animationTransition } from '@shared/utils/animationTransition';
import type { StyleSystemProps } from '@withjoy/joykit';
import { Flex, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import type { CSSObject } from '@withjoy/joykit/components/Box/Box.types';

export const StyledGiftBasketFloatingWidgetContainer = styled(Flex)``;
const giftBasketFloatingWidgetContainerStyles: CSSObject = {
  position: 'fixed',
  zIndex: 9,
  boxShadow: '0px 9px 36px -30px rgba(0, 0, 0, 0.04), 0px 10px 60px -20px rgba(44, 41, 37, 0.03), 0px 3px 8px 0px rgba(0, 0, 0, 0.03)',
  top: pxToRem(-55),
  right: pxToRem(32),
  borderRadius: pxToRem(48),
  opacity: 0,
  transition: animationTransition('top', 'opacity', 'box-shadow'),
  ['&.is-visible']: {
    top: pxToRem(80),
    opacity: 1,
  },
  _hover: {
    boxShadow: '0px 9px 36px -30px rgba(0, 0, 0, 0.3), 0px 10px 60px -20px rgba(44, 41, 37, 0.2), 0px 3px 8px 0px rgba(0, 0, 0, 0.2)',
  },
};

export const StyledGiftBasketFloatingWidgetButton = styled(Flex)``;
const giftBasketFloatingWidgetButtonStyles: StyleSystemProps = {
  alignItems: 'center',
  height: 9,
  paddingX: 5,
  backgroundColor: 'white',
  borderColor: 'mono14',
  border: '1px solid',
  borderRadius: `${pxToRem(48)} 0 0 ${pxToRem(48)}`,
  transition: animationTransition('background-color'),
  _notFirst: {
    borderLeft: 'none',
    borderRadius: `0 ${pxToRem(48)} ${pxToRem(48)} 0`,
  },
  _hover: {
    backgroundColor: 'fillLightHover',
  },
  _active: {
    backgroundColor: 'fillLightActive',
  },
};

export const styles = {
  giftBasketFloatingWidgetContainer: giftBasketFloatingWidgetContainerStyles,
  giftBasketFloatingWidgetButton: giftBasketFloatingWidgetButtonStyles,
};
